var SoftwareItemCollection = (function () {
    function SoftwareItemCollection(items, language) {
        if (items === void 0) { items = []; }
        if (language === void 0) { language = ''; }
        this.expanded = false;
        this.items = items.sort(function (softwareItem1, softwareItem2) {
            if (softwareItem1.languageTitle > softwareItem2.languageTitle) {
                return 1;
            }
            if (softwareItem1.languageTitle < softwareItem2.languageTitle) {
                return -1;
            }
            return 0;
        });
        this.selectedItem =
            this.items.filter(function (softwareItem) {
                return (softwareItem.marketLocales || []).some(function (ml) { return ml === language; });
            })[0] ||
                this.items.filter(function (softwareItem) {
                    return (softwareItem.marketLocales || []).some(function (ml) { return ml === "en-us"; });
                })[0] ||
                this.items[0];
        this.version = this.selectedItem === undefined ? '' : this.selectedItem.fileVersion;
    }
    return SoftwareItemCollection;
}());
export { SoftwareItemCollection };
